import HeroCarousel from "./components/HeroCarousel";
import CategoryEntries from "./components/CategoryEntries";
import HotVideos from "./components/HotVideos";
import LatestUpdates from "./components/LatestUpdates";
import SiteIntro from "./components/SiteIntro";
import { useSEO, SEO_HOME } from "@/hooks/useSEO";

export default function Home() {
  useSEO(SEO_HOME);

  return (
    <div className="w-full">
      <h1 className="sr-only">粉色视频 - 专业视频内容聚合平台</h1>
      <HeroCarousel />
      <div className="py-10 md:py-12">
        <CategoryEntries />
      </div>
      <div className="pb-12 md:pb-16">
        <HotVideos />
      </div>
      <LatestUpdates />
      <SiteIntro />
    </div>
  );
}